import { Routes, } from '@angular/router';
import { LandingScreenComponent } from './landing-screen/landing-screen.component';
import { DocumentViewComponent } from './document-view/document-view.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { InternalErrorComponent } from './internal-error/internal-error.component';

export const AppRoutes: Routes = [
    { path: '', redirectTo: '/app/dashboard', pathMatch: 'full' },
    { path: 'index', component: LandingScreenComponent },
    { path: '', loadChildren: './login/login.module#LoginModule' },
    { path: 'clinicianvideo', loadChildren: './clinician-video/clinician-video.module#ClinicianVideoModule' },
    { path: 'clientvideo', loadChildren: './video/video.module#VideoModule' },
    { path: 'docview/:fileUrl', component: DocumentViewComponent },
    { path: 'docview/:fileUrl/:source', component: DocumentViewComponent },
    { path: 'internal-error', component: InternalErrorComponent },
    { path: 'unauthorized', component: UnauthorizedComponent },
    { path: 'not-found', component: PageNotFoundComponent },
    {
        path: '**',
        redirectTo: '/not-found',
        pathMatch: 'full'
    }
];
